export const IMAGE = 'image';
export const AUDIO = 'audio';
export const VIDEO = 'video';
